import { render, staticRenderFns } from "./SettingsIndex.vue?vue&type=template&id=7912623e&"
import script from "./SettingsIndex.vue?vue&type=script&lang=ts&"
export * from "./SettingsIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports